import { Route } from '@angular/router';

export const NOT_FOUND_TITLE = 'Siden findes ikke';

/**
 * The not-found page as a route (#905): last in the app's routes, and last among the children of
 * a lazy parent with no page of its own (/resources, /legal). The router does not fall through
 * from such a parent to the app's `**`: with no segments left it activates the parent alone, a
 * blank page with status 200.
 */
export const notFoundRoute: Route = {
  path: '**',
  loadComponent: () => import('./not-found.component').then((m) => m.NotFoundComponent),
  title: NOT_FOUND_TITLE,
  data: { robots: 'noindex' },
};
